import { useFinanceAccess } from "@/shared/hooks/useFinanceAccess";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const SocioGuard = ({ children }: { children: React.ReactNode }) => {
  const { isSocio, loading } = useFinanceAccess();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isSocio) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default SocioGuard;
